module.exports = __webpack_public_path__ + "img/02.ea16a700.jpg";